module.exports = __webpack_public_path__ + "img/106.9e691f64.jpg";